import type { QueryClient } from '@tanstack/react-query'
import { taskKeys } from '../api/queries'
import type { Task } from '../model/schema'

// Оптимистично влить частичное обновление задачи во все кэши, где она лежит:
// detail, список доски, «мои». Зовётся в onMutate поверх снапшота beginOptimistic.
export function patchTaskCache(qc: QueryClient, id: string, patch: Partial<Task>): void {
  const prev = qc.getQueryData<Task>(taskKeys.detail(id))
  qc.setQueryData<Task>(taskKeys.detail(id), (t) => (t ? { ...t, ...patch } : t))
  const boardId = patch.boardId ?? prev?.boardId
  const patchItem = (list: Task[] | undefined) =>
    list?.map((t) => (t.id === id ? { ...t, ...patch } : t))
  if (boardId) qc.setQueryData<Task[]>(taskKeys.board(boardId), patchItem)
  qc.setQueryData<Task[]>(taskKeys.mine(), patchItem)
}
